"use strict";

import React, { Component, PropTypes } from "react";
import ReactDOM from "react-dom";
import ReactForm from ".\\ReactForm";

/******************************************************************************
** FormComponentBase
*/

let ReactFormFactory = new class {

	create(props, element) {
		let e = (typeof element == "string")
			? document.getElementById(element)
			: element
		;
		ReactDOM.render(React.createElement(ReactForm, props, null), e);
	}

}

export default ReactFormFactory;




/** WEBPACK FOOTER **
 ** ./forms/ReactFormFactory.js
 **/